import { http } from "./http";

export type InventoryItem = {
    id: string;
    partNumber: string;
    description: string;
    quantity: number;
    manufacturer: { name: string };
};

export const inventoryApi = {
    async search(text: string): Promise<InventoryItem[]> {
        const { data } = await http.post<InventoryItem[]>("/api/v0/inventory/search", { text });
        return data;
    },
};
